import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = "Cme/AdditClearing/Select";

export function RHFAdditClearingSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function AdditClearingSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
